import Typography from '../components/Typography';
import Video from '../components/Video';
import Layout from '../components/Layout';
import { useNavigate } from '@reach/router';

const VideoPreview = () => {
  const navigate = useNavigate();
  return (
    <Layout className="pt-4 px-6 pb-10">
      <Video />
      <div className="mb-4" />
      <Typography className="mb-4 text-[14px] text-center" weight="medium">
        Tap to preview your video
      </Typography>
      <button
        className="mb-4 cz-btn-brand w-full"
        onClick={() => navigate(`/gift-redeem/load/pay`)}
      >
        <Typography className="text-[14px]" color="white" weight="bold">
          Use This Video
        </Typography>
      </button>
      <button className="flex gap-x-1.5 w-full bg-white border-none cursor-pointer py-2 justify-center">
        <span className="my-auto">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M7.99958 3.3436V1.4686C7.99958 1.18735 7.62458 1.0311 7.43708 1.24985L4.90583 3.7811C4.78083 3.9061 4.78083 4.0936 4.90583 4.24985L7.43708 6.7811C7.62458 6.9686 7.99958 6.81235 7.99958 6.5311V4.6561C10.4996 4.6561 12.4683 6.93735 11.9058 9.5311C11.5933 11.0311 10.3746 12.2499 8.87458 12.5624C6.46833 13.0624 4.37458 11.4374 4.03083 9.2186C3.99958 8.9061 3.71833 8.6561 3.37458 8.6561C2.99958 8.6561 2.65583 9.0311 2.71833 9.4061C3.12458 12.3436 5.90583 14.4999 9.06208 13.9061C11.1558 13.4999 12.8121 11.8124 13.2183 9.74985C13.9058 6.31235 11.2808 3.3436 7.99958 3.3436Z"
              fill="#0A2540"
            />
          </svg>
        </span>
        <Typography className="text-[14px] my-auto" weight="semibold">
          Try Again
        </Typography>
      </button>
    </Layout>
  );
};

export default VideoPreview;
